import Vue from "vue";

export default new Vue({
  methods: {
    scrollToTop() {
      this.$emit("scrollToTop");
    },
    scrollToTopMobile(val) {
      this.$emit("scrollToTopMobile",val);
    },
    checkConsumerDirect(val) {
      console.log('event bus being called!!!!!', val);
      this.$root.$emit("checkConsumerDirect", val);
    }
  }
});
